
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningBadgeOutline as ObiWarningBadgeOutlineElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-badge-outline.js';
 
 
 

 
 export const ObiWarningBadgeOutline = createComponent({
   react: React,
   tagName: 'obi-warning-badge-outline',
   elementClass: ObiWarningBadgeOutlineElement,
   events: {
     
   }
  });
 
 